import { render } from "./PaywallCallToAction.vue?vue&type=template&id=5e533964"
import script from "./PaywallCallToAction.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallCallToAction.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallCallToAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e533964"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e533964', __exports__)) {
    api.reload('5e533964', __exports__)
  }
  
  module.hot.accept("./PaywallCallToAction.vue?vue&type=template&id=5e533964", () => {
    api.rerender('5e533964', render)
  })

}


export default __exports__